import { DocLayout } from './DocLayout';

export default function DocDpa() {
  return (
    <DocLayout title="Acord de Prelucrare a Datelor (DPA)">
      <h2>Ce este DPA?</h2>
      <p>
        Acordul de Prelucrare a Datelor (DPA — Data Processing Agreement) este un document juridic
        obligatoriu conform GDPR care reglementează modul în care organizațiile partenere (procesatori de date)
        primesc și gestionează datele personale ale participanților la activități.
      </p>
      <p>
        Operatorul de date este <strong>Asociația Eu Sunt</strong> (CIF: 34347234).
        Partenerii organizatori devin procesatori de date pentru activitățile pe care le organizează.
      </p>

      <h2>De ce este necesar?</h2>
      <p>
        Conform Regulamentului General privind Protecția Datelor (GDPR), orice transfer de date personale
        către terți trebuie reglementat printr-un acord formal. DPA-ul asigură că:
      </p>
      <ul>
        <li>Datele participanților sunt prelucrate doar în scopul organizării activităților.</li>
        <li>Partenerul respectă obligații clare de confidențialitate și securitate.</li>
        <li>Există reguli clare privind durata păstrării și ștergerea datelor.</li>
        <li>Participanții sunt informați și își dau consimțământul explicit.</li>
      </ul>

      <h2>Ce date sunt partajate?</h2>
      <p>Partenerii validați primesc acces la următoarele date ale participanților la activitățile lor:</p>
      <ul>
        <li>Prenume și nume</li>
        <li>Adresă de email</li>
        <li>Număr de telefon (dacă a fost furnizat)</li>
        <li>Vârstă (calculată din data nașterii, dacă a fost furnizată)</li>
      </ul>

      <h2>Cerințe pentru semnare</h2>
      <p>Înainte de a putea semna DPA-ul, organizația trebuie să completeze toate câmpurile legale:</p>
      <ol>
        <li><strong>Denumire legală</strong> — numele oficial al organizației.</li>
        <li><strong>CIF/CUI</strong> — codul de identificare fiscală.</li>
        <li><strong>Sediu social</strong> — adresa oficială.</li>
        <li><strong>Reprezentant legal (nume)</strong> — persoana care semnează.</li>
        <li><strong>Funcția reprezentantului</strong> — ex: Președinte, Administrator.</li>
      </ol>
      <p>Dacă lipsesc câmpuri, pagina DPA le afișează și blochează butonul de acceptare.</p>

      <h2>Fluxul de semnare</h2>
      <ol>
        <li>Accesează <strong>Organizațiile mele</strong> → click pe butonul <strong>DPA</strong>.</li>
        <li>Completează datele legale lipsă din profilul organizației (dacă e cazul).</li>
        <li>Citește textul complet al acordului pe pagina DPA.</li>
        <li>Click pe <strong>Acceptă DPA</strong>.</li>
        <li>Sistemul înregistrează data, ora și adresa IP a acceptării.</li>
        <li>Organizația devine <strong>validată</strong>.</li>
      </ol>

      <h2>Efectele validării</h2>
      <h3>Partener validat</h3>
      <ul>
        <li>Acces complet la datele participanților pentru activitățile organizate.</li>
        <li>Funcții de printare și export CSV disponibile.</li>
        <li>Badge <strong>Validat</strong> afișat în profil.</li>
      </ul>

      <h3>Partener nevalidat</h3>
      <ul>
        <li>Poate vedea lista de participanți, dar datele personale sunt ascunse (afișate ca ••••).</li>
        <li>Funcțiile de printare și export CSV nu sunt disponibile.</li>
        <li>Poate vedea numărul total de participanți, statusul și datele de înregistrare.</li>
      </ul>

      <h2>Modificarea datelor legale</h2>
      <p>
        Dacă datele legale ale organizației se modifică după semnarea DPA:
      </p>
      <ul>
        <li>Datele legale sunt blocate în mod implicit (afișate doar în citire).</li>
        <li>Pentru a le edita, trebuie confirmată intenția — un dialog avertizează că DPA-ul va fi invalidat.</li>
        <li>La salvarea modificărilor, DPA-ul este automat revocat.</li>
        <li>Organizația revine la status <strong>Nevalidat</strong> și trebuie re-semnat DPA-ul.</li>
      </ul>
      <p>
        Această măsură asigură că datele din DPA corespund întotdeauna cu datele reale ale organizației.
      </p>

      <h2>Expirarea accesului</h2>
      <p>
        Accesul la datele participanților expiră la <strong>30 de zile</strong> după data de final a activității.
        După această perioadă, lista de participanți nu mai este accesibilă partenerului.
      </p>

      <h2>Revocare de către staff</h2>
      <p>
        Superadminii pot revoca manual DPA-ul unui partener din pagina de gestionare a partenerilor.
        Revocarea resetează validarea și blochează accesul la datele participanților.
      </p>
    </DocLayout>
  );
}
